import { Trans } from '@lingui/macro';
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useMemo, useState } from 'react';
import { ConnectWalletPaper } from 'src/components/ConnectWalletPaper';
import { ListWrapper } from 'src/components/lists/ListWrapper';
import { applyTxHistoryFilters, useTransactionHistory } from 'src/hooks/useTransactionHistory';
import { useWeb3Context } from 'src/libs/hooks/useWeb3Context';
// import { SearchInput } from 'src/components/SearchInput';


import { HistoryFilterMenu } from './HistoryFilterMenu';
import { HistoryWrapperMobile } from './HistoryWrapperMobile';
import { EOperationType } from './types';
import TransactionRowItem from './TransactionRowItem';
import { groupByDate } from './helpers';

export const HistoryWrapper = () => {
  // const [searchQuery, setSearchQuery] = useState('');
  const [filterQuery, setFilterQuery] = useState<EOperationType[]>([]);
  // const [searchResetKey, setSearchResetKey] = useState(0);

  const {
    data: transactions,
  } = useTransactionHistory();

  const theme = useTheme();
  const downToMD = useMediaQuery(theme.breakpoints.down('md'));
  const { currentAccount, loading: web3Loading } = useWeb3Context();

  const filteredTxns = useMemo(
    () => applyTxHistoryFilters({ filterQuery, txns: transactions }),
    [filterQuery, transactions]
  );

  if (!currentAccount) {
    return (
      <ConnectWalletPaper
        loading={web3Loading}
        description={<Trans> Please connect your wallet to view transaction history.</Trans>}
      />
    );
  }

  if (downToMD) {
    return <HistoryWrapperMobile />;
  }

  const isEmpty = filteredTxns.length === 0;
  const filterActive = filterQuery.length > 0;
  // const filterActive = searchQuery !== '' || filterQuery.length > 0;

  return (
    <ListWrapper
      titleComponent={
        <Box sx={{ width: '100%', display: 'inline-flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography component="div" variant="h2" sx={{ mr: 4, fontSize: '20px' }}>
            <Trans>Transactions</Trans>
          </Typography>
          <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
            <HistoryFilterMenu onFilterChange={setFilterQuery} currentFilter={filterQuery} />
            {/*<SearchInput*/}
            {/*  onSearchTermChange={setSearchQuery}*/}
            {/*  placeholder="Search assets..."*/}
            {/*  wrapperSx={{ width: '280px' }}*/}
            {/*  key={searchResetKey}*/}
            {/*/>*/}
          </Box>
        </Box>
      }
    >
      {!isEmpty ? (
        Object.entries(groupByDate(filteredTxns)).map(([date, txns], groupIndex) => (
          <React.Fragment key={groupIndex}>
            <Typography
              variant="main16"
              color="text.primary" sx={{
                px: 6,
                py: 3,
                borderTop: '1px solid rgba(255, 255, 255, 0.06)',
              }}
            >
              {date}
            </Typography>
            {txns.map((transaction, index: number) => {
              return (
                <div ref={null} key={index}>
                  <TransactionRowItem transaction={transaction} />
                </div>
              );
            })}
          </React.Fragment>
        ))
      ) : filterActive ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            p: 4,
            flex: 1,
            maxWidth: '468px',
            margin: '0 auto',
            my: 24,
          }}
        >
          <Typography variant="h3" color="text.primary">
            <Trans>Nothing found</Trans>
          </Typography>
          <Typography sx={{ mt: 1, mb: 4 }} variant="description" color="text.secondary">
            <Trans>
              We couldn&apos;t find any transactions related to your search. Try again with a
              different asset name, or reset filters.
            </Trans>
          </Typography>
          <Button
            variant="outlined"
            onClick={() => {
              setFilterQuery([]);
              // setSearchQuery('');
              // setSearchResetKey((prevKey) => prevKey + 1); // Remount SearchInput component to clear search query
            }}
          >
            Reset Filters
          </Button>
        </Box>
      ) : (
        <></>
      )}
    </ListWrapper>
  );
};

export default HistoryWrapper;
